import toast from 'react-hot-toast';

export const responseToast = async (response) => {
  if (response.status === 200) {
    toast.success(response.data.message, { duration: 5000 });
  } else if (response.status === 404) {
    toast.error(response.data.message);
  } else {
    toast.error('General error');
  }
};

class ErrorService {
  error(response) {
    if (response.status === 200) {
      toast.success(response.data.message, { duration: 5000 });
    } else if (response.status === 404) {
      toast.error(response.data.message);
    }
  }
}

export const errorService = new ErrorService();
